import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

/**
 * Wrap routes that require authentication. Uses Outlet for nested routes.
 * @param {{ role?: 'admin' | 'student' | 'superadmin' }} props
 */
export default function ProtectedRoute({ role }) {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner message="Checking your access…" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (role === 'superadmin') {
    if (user?.role !== 'admin' || !user?.isSuperadmin) return <Navigate to={user?.role === 'admin' ? '/admin' : '/dashboard'} replace />;
  } else if (role && user?.role !== role) {
    return <Navigate to={user?.role === 'admin' ? '/admin' : '/dashboard'} replace />;
  }

  return <Outlet />;
}
